module.exports = __webpack_public_path__ + "aeb756e1122f5ea28eca536c9580dbf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/clear-table.png
// module id = 720
// module chunks = 0